
import React from "react";

interface AdvancedTierDataProps {
  tierData: any;
}

export default function AdvancedTierData({ tierData }: AdvancedTierDataProps) {
  if (!tierData) return <p className="text-white/70">No tier data available</p>;
  
  return (
    <div className="space-y-3">
      {tierData.currentProgramDetails && (
        <div className="flex flex-col md:flex-row md:gap-2">
          <span className="text-white/80 md:w-40">Current Program:</span>
          <span className="text-white flex-1">{tierData.currentProgramDetails}</span>
        </div>
      )}
      {tierData.trainingPhilosophy && (
        <div className="flex flex-col md:flex-row md:gap-2">
          <span className="text-white/80 md:w-40">Training Philosophy:</span>
          <span className="text-white flex-1">{tierData.trainingPhilosophy}</span>
        </div>
      )}
      {tierData.hasPeriodizationExperience && (
        <div className="flex flex-col md:flex-row md:gap-2">
          <span className="text-white/80 md:w-40">Periodization Experience:</span>
          <span className="text-white flex-1">
            {tierData.hasPeriodizationExperience === "yes" ? "Has experience with periodization" : 
             (tierData.hasPeriodizationExperience === "no" ? "No periodization experience" : "Periodization experience unknown")}
          </span>
        </div>
      )}
      {tierData.periodizationApproach && (
        <div className="flex flex-col md:flex-row md:gap-2">
          <span className="text-white/80 md:w-40">Periodization Approach:</span>
          <span className="text-white flex-1">{tierData.periodizationApproach}</span>
        </div>
      )}
      {tierData.performanceTracking && (
        <div className="flex flex-col md:flex-row md:gap-2">
          <span className="text-white/80 md:w-40">Performance Tracking:</span>
          <span className="text-white flex-1">
            {tierData.performanceTracking === "app" ? "Mobile App" :
             tierData.performanceTracking === "spreadsheet" ? "Spreadsheet" :
             tierData.performanceTracking === "coach" ? "Coach/Trainer" : "Does not track"}
          </span>
        </div>
      )}
      {tierData.recentPerformance && (
        <div className="flex flex-col md:flex-row md:gap-2">
          <span className="text-white/80 md:w-40">Recent Performance:</span>
          <span className="text-white flex-1">{tierData.recentPerformance}</span>
        </div>
      )}
      {tierData.weaknesses && (
        <div className="flex flex-col md:flex-row md:gap-2">
          <span className="text-white/80 md:w-40">Weaknesses:</span>
          <span className="text-white flex-1">{tierData.weaknesses}</span>
        </div>
      )}
    </div>
  );
}
